module.exports = __webpack_public_path__ + "static/media/leaderboard-img3.7fc15ef8.jpeg";